import BRAND_CODES from './brand-codes';
import PRIVACY_BRAND_CONFIG from './privacy';
import PSMS_BRAND_CONFIG from './psms';
import MG_SAFE_BRAND_CONFIG from './mgsafe';
import DSHOP_BRAND_CONFIG from './dshop';
import DSAFE_BRAND_CONFIG from './dsafe';
import PARTYHAT_BRAND_CONFIG from './partyhat';
import PROTECTIV_BRAND_CONFIG from './protectiv';
import PHSAFE_BRAND_CONFIG from './phsafe';
import IDENTITY_DEFENSE_BRAND_CONFIG from './iddefense';
import DEFAULT_BRAND_CONFIG from './default';
import type { BrandConfigType } from './types';
import MEDICALSHIELD_BRAND_CONFIG from './mshield';
import DMINOR_BRAND_CONFIG from './dminor';
import FINANCIAL_SHIELDCIAL_SHIELD_BRAND_CONFIG from './afs2';
import ANPAC_BRAND_CONFIG from './anpac';
import COMERICA_BRAND_CONFIG from './comerica';
import AOL_IDG_BRAND_CONFIG from './aolidg';
import CRED_NOTIFY_BRAND_CONFIG from './creditnotify';
import HTG_BRAND_CONFIG from './hometitle';
import IDG_BRAND_CONFIG from './idguard';
import BARCLAYS_BRAND_CONFIG from './barclays';
import PRIVACY_ASSIST_BRAND_CONFIG from './boapa';
import BOF_WEST_BRAND_CONFIG from './bofwest';
import ENGUARD_BRAND_CONFIG from './enguard';
import DISCOVER_BRAND_CONFIG from './discover';
import TOTALAV_BRAND_CONFIG from './totalav';
import SCANGUARD_BRAND_CONFIG from './scanguard';
import SCANGUARD1_BRAND_CONFIG from './scanguard1';
import PCPROTECT_BRAND_CONFIG from './pcprotect';
import PCPROTECT1_BRAND_CONFIG from './pcprotect1';
import CREDITMON_BRAND_CONFIG from './creditmon';
import ULTRAAV_BRAND_CONFIG from './ultraav';
import PRADVANTAGE_BRAND_CONFIG from './pradvantage';

const BRAND_CONFIG: BrandConfigType = {
  [BRAND_CODES.anpac]: ANPAC_BRAND_CONFIG,
  [BRAND_CODES.comerica]: COMERICA_BRAND_CONFIG,
  [BRAND_CODES.aolidg]: AOL_IDG_BRAND_CONFIG,
  [BRAND_CODES.creditnotify]: CRED_NOTIFY_BRAND_CONFIG,
  [BRAND_CODES.homeTitleGuardian]: HTG_BRAND_CONFIG,
  [BRAND_CODES.idguard]: IDG_BRAND_CONFIG,
  [BRAND_CODES.barclays]: BARCLAYS_BRAND_CONFIG,
  [BRAND_CODES.myPrivacyAssist]: PRIVACY_ASSIST_BRAND_CONFIG,
  [BRAND_CODES.bofwest]: BOF_WEST_BRAND_CONFIG,
  [BRAND_CODES.discover]: DISCOVER_BRAND_CONFIG,
  [BRAND_CODES.enguard]: ENGUARD_BRAND_CONFIG,
  [BRAND_CODES.pcprotect]: PCPROTECT_BRAND_CONFIG,
  [BRAND_CODES.pcprotect1]: PCPROTECT1_BRAND_CONFIG,
  [BRAND_CODES.scanguard]: SCANGUARD_BRAND_CONFIG,
  [BRAND_CODES.scanguard1]: SCANGUARD1_BRAND_CONFIG,
  [BRAND_CODES.privacyShield]: PRIVACY_BRAND_CONFIG,
  [BRAND_CODES.privacyMedicalShield]: PSMS_BRAND_CONFIG,
  [BRAND_CODES.missGroupSafe]: MG_SAFE_BRAND_CONFIG,
  [BRAND_CODES.domeneShop]: DSHOP_BRAND_CONFIG,
  [BRAND_CODES.domainkeskusSafe]: DSAFE_BRAND_CONFIG,
  [BRAND_CODES.partyhat]: PARTYHAT_BRAND_CONFIG,
  [BRAND_CODES.protectIV]: PROTECTIV_BRAND_CONFIG,
  [BRAND_CODES.phSafe]: PHSAFE_BRAND_CONFIG,
  [BRAND_CODES.identityDefense]: IDENTITY_DEFENSE_BRAND_CONFIG,
  [BRAND_CODES.financialShield]: FINANCIAL_SHIELDCIAL_SHIELD_BRAND_CONFIG,
  [BRAND_CODES.medicalShield]: MEDICALSHIELD_BRAND_CONFIG,
  [BRAND_CODES.minorDefense]: DMINOR_BRAND_CONFIG,
  [BRAND_CODES.totalAv]: TOTALAV_BRAND_CONFIG,
  [BRAND_CODES.ultraAv]: ULTRAAV_BRAND_CONFIG,
  [BRAND_CODES.creditmon]: CREDITMON_BRAND_CONFIG,
  [BRAND_CODES.pradvantage]: PRADVANTAGE_BRAND_CONFIG,
  default: DEFAULT_BRAND_CONFIG,
};

export default BRAND_CONFIG;
